module.exports = [{
      plugin: require('/Users/afairb/Desktop/Development/work-blog/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-26007839-2"},
    },{
      plugin: require('/Users/afairb/Desktop/Development/work-blog/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
